<template>
  <div class="app-footer" v-if="enableFooter">
    <EmbeddableFooter :sharing-options-values="sharingOptionsValues">
      <div class="d-none d-sm-block">
        <BButton variant="link" pill class="text-white float-right mr-1 font-weight-bold" @click.prevent="toggleAbout">
          {{ $t('appFooter.about') }}
        </BButton>
        <BButton variant="link" pill class="text-white float-right mr-1 font-weight-bold" @click.prevent="toggleCredits">
          {{ $t('appFooter.credits') }}
        </BButton>
      </div>
    </EmbeddableFooter>
    <div class="mx-2 mb-2 d-flex d-sm-none">
      <BButton variant="link" pill class="text-white font-weight-bold text-left" block @click.prevent="toggleCredits">
        {{ $t('appFooter.credits') }}
      </BButton>
      <BButton variant="link" pill class="m-0 text-white font-weight-bold text-right" block @click.prevent="toggleAbout">
        {{ $t('appFooter.about') }}
      </BButton>
    </div>
    <portal to="overlay">
      <ContentOverlay :title="$t('about.title')" @close="toggleAbout" v-if="showAbout" class="app-footer__about">
        <div v-html="about"></div>
      </ContentOverlay>
      <ContentOverlay :title="$t('credits.title')" @close="toggleCredits" v-if="showCredits">
        <div v-html="credits"></div>
      </ContentOverlay>
    </portal>
  </div>
</template>

<script>
import get from 'lodash/get'
import snarkdown from 'snarkdown'

import ContentOverlay from '@/components/ContentOverlay'
import utils from '@/mixins/utils'

export default {
  name: 'AppFooter',
  components: {
    ContentOverlay
  },
  mixins: [utils],
  data () {
    return {
      enableFooter: true,
      showAbout: false,
      showCredits: false
    }
  },
  computed: {
    about () {
      return snarkdown(this.$t('about.body'))
    },
    credits () {
      return snarkdown(this.$t('credits.body'))
    },
    imageUrl () {
      return this.getFullUrl('fincen_files_social.png')
    },
    sharingOptionsValues() {
      return {
        url: this.url,
        title: 'Meet the fugitive financier, oligarchs, business tycoons and entrepreneurs in the FinCEN Files.',
        description: 'These are the people zipping money across the world thanks to the global banking system. ' + this.url,
        image: this.imageUrl,
        twitter_title: 'A cryptocurrency queen, a fugitive financier, politicians, business tycoons, and more. @ICIJorg found them all in the #FinCENFiles',
        twitter_description: 'These people are using the world\'s biggest banks to zip money across the globe.'
      }
    },
    url () {
      return this.getFullUrl(this.$router.resolve({ name: 'list' }).href)
    }
  },
  methods: {
    toggleAbout () {
      this.showAbout = !this.showAbout
    },
    toggleCredits () {
      this.showCredits = !this.showCredits
    }
  },
  beforeMount () {
    const enableFooter = get(this.$route, ['query', 'enableFooter'], true)
    this.$set(this, 'enableFooter', String(enableFooter).toLowerCase() === 'true')
  },
}
</script>

<style lang="scss" scoped>
  .app-footer {
    background: #333;
    box-shadow: 0 0 0 2px #000;

    /deep/ .embeddable-footer {
      background: inherit;
      position: relative;
      z-index: -1;

      & > .embeddable-footer__lead {
        overflow: visible;
      }

      & > .embeddable-footer__brand {
        border-right: 0;
        font-family: var(--font-family-sans-serif);

        svg {
          margin: 0 .5rem;
          transform: scale(1.5);
        }
      }
    }

    &__about {
      /deep/ {
        h1 {
          font-size: 2rem;
          margin-top: 5vh;
        }

        h2 {
          font-size: 1.5rem;
          margin-top: 3vh;
        }

        li {
          margin-bottom: 1.5rem;
        }
      }
    }
  }
</style>
